import apis from './config';
//
const articleApi = apis.article;

export const saveArticle = async (articleData) => {
    try {
        const response = await articleApi.post('/', articleData, {
            retag: true,
            validateCsrf: true,
        });
        return response.data;
    } catch (error) {
        console.error('Error saving article:', error);
        throw error;
    }
};

export const uploadMedia = async (file) => {
    try {
        const formData = new FormData();
        formData.append('file', file);

        const response = await articleApi.post('/media', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            retag: true,
            validateCsrf: true,
        });
        return response.data.mediaId;
    } catch (error) {
        console.error('Error uploading media:', error);
        throw error;
    }
};

export const fetchArticles = async () => {
    try {
        // Use the same endpoint as ArticlesGrid was using
        const response = await articleApi.get('/?includeInvisible=true&includeBody=false', {
            headers: { Accept: 'application/json' },
        });

        // Handle different response formats
        const data = response.data;
        const articles = Array.isArray(data) ? data : Array.isArray(data.items) ? data.items : [];

        return articles;
    } catch (error) {
        console.error('Error fetching articles:', error);
        throw error;
    }
};

export const fetchArticleById = async (id) => {
    try {
        const response = await articleApi.get(`/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching article:', error);
        throw error;
    }
};

export const deleteArticle = async (id) => {
    try {
        const response = await articleApi.delete(`/${id}`, {
            retag: true,
            validateCsrf: true,
        });
        return response.data;
    } catch (error) {
        console.error('Error deleting article:', error);
        throw error;
    }
};

export const updateArticle = async (id, articleData) => {
    try {
        const response = await articleApi.put(`/${id}`, articleData, {
            retag: true,
            validateCsrf: true,
        });
        return response.data;
    } catch (error) {
        console.error('Error updating article:', error);
        throw error;
    }
};

// Toggle article visibility/publication status
export const toggleArticleVisibility = async (id, isVisible) => {
    try {
        const response = await articleApi.patch(
            `/${id}`,
            { visible: isVisible },
            {
                retag: true,
                validateCsrf: true,
            }
        );
        return response.data;
    } catch (error) {
        console.error('Error updating article visibility:', error);
        throw error;
    }
};
